import { SVGS } from '@/assets/svgs'
import colors from '@/styles/colors'
import { AccentSlidersData, PatternDraft, Topic } from '@/types'
import { FileUploadOutlined, ImageOutlined } from '@mui/icons-material'
import pattern from '@/pages/topic-details/pattern'

export interface ConstantsObject {
  imagePickerLimit: number
}

export const Constants: ConstantsObject = {
  imagePickerLimit: 10,
}

export const HOME_PATH = '/discover/home'
export const NOT_FOUNT_PATH = '/not-found'

export const DiscoverTabPaths = [
  {
    key: 'DISCOVER_SHARE',
    path: '/discover/home',
    title: 'Home',
    icon: SVGS.TabHome,
  },
  {
    key: 'DISCOVER_PATTERN',
    path: '/discover/pattern',
    title: 'Patterns',
    icon: SVGS.TabPattern,
  },
  // {
  //   key: 'DISCOVER_QUILT',
  //   path: '/discover/quilt',
  //   title: 'Quilts',
  //   icon: SVGS.TabQuilt,
  // },
  // {
  //   key: 'DISCOVER_CUSTOM_PRINT',
  //   path: '/discover/custom_print',
  //   title: 'Custom Prints',
  //   icon: SVGS.TabQuilt,
  // },
  {
    key: 'DISCOVER_ALBUM',
    path: '/discover/album',
    title: 'Collections',
    icon: SVGS.TabAlbum,
  },
  // {
  //   key: 'DISCOVER_GALLERY',
  //   path: '/discover/gallery',
  //   title: 'Gallery',
  //   icon: SVGS.TabGallery,
  // },
]

export const ContributeTabPaths = [
  {
    key: 'CONTRIBUTE_CONNECTION',
    path: '/contribute/connection',
    title: 'Discussion',
    icon: SVGS.TabConnect,
  },
  {
    key: 'CONTRIBUTE_QUESTION',
    path: '/contribute/qna',
    title: 'Answer Questions',
    icon: SVGS.TabQuestion,
  },
]

export const WorkspaceTabPaths = [
  {
    key: 'WORKSPACE_SHARE',
    path: '/workspace/all',
    title: 'All',
    icon: SVGS.TabCircle,
  },
  {
    key: 'WORKSPACE_PATTERN',
    path: '/workspace/pattern',
    title: 'Patterns',
    icon: SVGS.TabPattern,
  },
  // {
  //   key: 'WORKSPACE_CUSTOM_PRINT',
  //   path: '/workspace/custom_print',
  //   title: 'Custom Prints',
  //   icon: SVGS.TabQuilt,
  // },
  {
    key: 'WORKSPACE_ALBUM',
    path: '/workspace/album',
    title: 'Collections',
    icon: SVGS.TabAlbum,
  },
  // {
  //   key: 'WORKSPACE_GALLERY',
  //   path: '/workspace/gallery',
  //   title: 'Gallery',
  //   icon: SVGS.TabGallery,
  // },

  // {
  //   key: 'WORKSPACE_UPLOAD',
  //   path: '/workspace/upload',
  //   title: 'Uploads',
  //   icon: SVGS.TabUpload,
  // },

  {
    key: 'WORKSPACE_NEW',
    path: '/topic/create',
    title: 'Create New',
    icon: SVGS.TabPlus,
  },
]

export const ProjectTabPaths = [
  {
    key: 'PROJECT_QUILT',
    path: '/projects/quilt',
    title: 'Quilts',
    icon: SVGS.TabQuilt,
  },
  {
    key: 'PROJECT_GALLERY',
    path: '/projects/gallery',
    title: 'Gallery',
    icon: SVGS.TabGallery,
  },
]

export enum ResourceType {
  CONNECTION = 1,
  GROUP = 2,
  TOPIC = 3,
}

export const PERMRESOURCE_TOPIC = 6

export enum PrivacyType {
  ALL = 0,
  PUBLIC = 1,
  REMOVED = 2, // PREVIOUSLY USED FOR EGOWALLMEMBERS
  PRIVATE = 3,
  CONNECTIONS = 4,
  CIRCLES = 5,
  ONETOONE = 6,
  BROADCAST = 7, // Public broadcast - appears on guest landing page
}

// Note: keep the type at it's corresponding index, e.g. type: 0 at index 0
export const PrivacyTypes = [
  {
    label: 'All',
    type: 0,
    icon: SVGS.FilterPrivacyAll,
  },
  {
    label: 'Public',
    type: 1,
    icon: SVGS.FilterPrivacyPublic,
    color: colors.darkRed,
  },
  {
    label: 'Removed',
    type: 2,
    icon: SVGS.FilterPrivacyPublic,
    color: colors.darkRed,
  },
  {
    label: 'Private',
    type: 3,
    icon: SVGS.FilterPrivacyPrivate,
    color: colors.blue,
  },
  {
    label: 'Connections',
    type: 4,
    icon: SVGS.FilterPrivacyConnection,
    color: colors.purple,
  },
  {
    label: 'Circles',
    type: 5,
    icon: SVGS.FilterPrivacyCircle,
    color: colors.darkYellow,
  },
  {
    label: 'One on One',
    type: 6,
    icon: SVGS.FilterPrivacyOneToOne,
    color: colors.green,
  },
]

export enum TopicType {
  ALL = 0,
  LIST = 1,
  ALBUM = 2,
  TASK = 3,
  DISCUSSION = 4,
  DOCUMENT = 5,
  MESSAGE = 6,
  DIRECT_MESSAGE = 7,
  NOTES = 8,
  SYSTEM_PROVIDED = 100,
  PATTERN = 200,
  GALLERY = 201,
  WALL_ART = 202,
  QUILT = 203,
  QNA = 204,
  CUSTOM_PRINTS = 205,
  PIN_COLLECTION = 110,
}

export type TopicTypeInfo = {
  key: string
  label: string
  type: number
  title: string
  icon: string
  outlineIcon: string
  gridIcon: string
  gridSelectedIcon: string
  color: string
  tabTitle: string
}

export const TopicTypes: Record<string, TopicTypeInfo> = {
  [TopicType.ALL]: {
    key: 'all',
    label: 'All',
    type: TopicType.ALL,
    title: 'Topic',
    tabTitle: 'All',
    icon: SVGS.FilterTopicAll,
    outlineIcon: SVGS.FilterTopicAll,
    gridIcon: SVGS.FilterTopicAll,
    gridSelectedIcon: SVGS.FilterTopicAll,
    color: colors.text,
  },

  [TopicType.LIST]: {
    key: 'list',
    label: 'List',
    type: TopicType.LIST,
    title: 'List',
    tabTitle: 'Lists',
    icon: SVGS.FilterTopicList,
    outlineIcon: SVGS.FilterTopicList,
    gridIcon: SVGS.PatternIcon,
    gridSelectedIcon: SVGS.PatternSelectedIcon,
    color: colors.blue,
  },

  [TopicType.ALBUM]: {
    key: 'collection',
    label: 'Collection',
    type: TopicType.ALBUM,
    title: 'Collection',
    tabTitle: 'Collections',
    icon: SVGS.FilterTopicAlbum,
    outlineIcon: SVGS.AlbumOutlineIconPlaceholder,
    gridIcon: SVGS.AlbumIcon,
    gridSelectedIcon: SVGS.AlbumSelectedIcon,
    color: '#ec4899',
  },

  [TopicType.PIN_COLLECTION]: {
    key: 'pin_collection',
    label: 'Pin Collection',
    type: TopicType.PIN_COLLECTION,
    title: 'Pin Collection',
    tabTitle: 'Pin Collections',
    icon: SVGS.FilterTopicAlbum,
    outlineIcon: SVGS.AlbumOutlineIconPlaceholder,
    gridIcon: SVGS.AlbumIcon,
    gridSelectedIcon: SVGS.AlbumSelectedIcon,
    color: '#ec4899',
  },

  [TopicType.TASK]: {
    key: 'task',
    label: 'Task List',
    type: TopicType.TASK,
    title: 'Task List',
    tabTitle: 'Task Lists',
    icon: SVGS.FilterTopicTaskList,
    outlineIcon: SVGS.FilterTopicAlbum,
    gridIcon: SVGS.PatternIcon,
    gridSelectedIcon: SVGS.PatternSelectedIcon,
    color: colors.text,
  },
  [TopicType.DISCUSSION]: {
    key: 'discussion',
    label: 'Discussion',
    type: TopicType.DISCUSSION,
    title: 'Discussion',
    tabTitle: 'Discussion',
    icon: SVGS.FilterTopicDiscussion,
    outlineIcon: SVGS.FilterTopicDiscussion,
    gridIcon: SVGS.DiscussionIcon,
    gridSelectedIcon: SVGS.DiscussionSelectedIcon,
    color: colors.text,
  },

  [TopicType.DOCUMENT]: {
    key: 'document',
    label: 'Document',
    type: TopicType.DOCUMENT,
    title: 'Document',
    tabTitle: 'Document',
    icon: SVGS.FilterTopicTaskList,
    outlineIcon: SVGS.FilterTopicTaskList,
    gridIcon: SVGS.PatternIcon,
    gridSelectedIcon: SVGS.PatternSelectedIcon,
    color: colors.text,
  },

  [TopicType.MESSAGE]: {
    key: 'message',
    label: 'Message',
    type: TopicType.MESSAGE,
    title: 'Message',
    tabTitle: 'Message',
    icon: SVGS.FilterTopicTaskList,
    outlineIcon: SVGS.FilterTopicTaskList,
    gridIcon: SVGS.PatternIcon,
    gridSelectedIcon: SVGS.PatternSelectedIcon,
    color: colors.text,
  },

  [TopicType.DIRECT_MESSAGE]: {
    key: 'direct_message',
    label: 'Direct Message',
    type: TopicType.DIRECT_MESSAGE,
    title: 'Direct Message',
    tabTitle: 'Direct Message',
    icon: SVGS.FilterTopicTaskList,
    outlineIcon: SVGS.FilterTopicTaskList,
    gridIcon: SVGS.PatternIcon,
    gridSelectedIcon: SVGS.PatternSelectedIcon,
    color: colors.text,
  },

  [TopicType.NOTES]: {
    key: 'notes',
    label: 'Notes',
    type: TopicType.NOTES,
    title: 'Notes',
    tabTitle: 'Notes',
    icon: SVGS.FilterTopicTaskList,
    outlineIcon: SVGS.FilterTopicTaskList,
    gridIcon: SVGS.PatternIcon,
    gridSelectedIcon: SVGS.PatternSelectedIcon,
    color: colors.text,
  },

  [TopicType.SYSTEM_PROVIDED]: {
    key: 'systemProvided',
    label: 'Message',
    type: TopicType.SYSTEM_PROVIDED,
    title: 'Message',
    tabTitle: 'Message',
    icon: SVGS.FilterTopicTaskList,
    outlineIcon: SVGS.FilterTopicTaskList,
    gridIcon: SVGS.PatternIcon,
    gridSelectedIcon: SVGS.PatternSelectedIcon,
    color: colors.text,
  },

  [TopicType.PATTERN]: {
    key: 'pattern',
    label: 'Pattern',
    type: TopicType.PATTERN,
    title: 'Pattern',
    tabTitle: 'Patterns',
    icon: SVGS.FilterTopicList,
    outlineIcon: SVGS.PatternOutline,
    gridIcon: SVGS.PatternIcon,
    gridSelectedIcon: SVGS.PatternSelectedIcon,
    color: '#7c3aed',
  },

  [TopicType.GALLERY]: {
    key: 'gallery',
    label: 'Gallery',
    type: TopicType.GALLERY,
    title: 'Gallery',
    tabTitle: 'Galleries',
    icon: SVGS.FilterTopicList,
    outlineIcon: SVGS.GalleryOutlineIcon,
    gridIcon: SVGS.GalleryIcon,
    gridSelectedIcon: SVGS.GallerySelectedIcon,
    color: colors.text,
  },

  [TopicType.QUILT]: {
    key: 'quilt',
    label: 'Quilt',
    type: TopicType.QUILT,
    title: 'Quilt',
    tabTitle: 'Quilts',
    icon: SVGS.QuiltIcon,
    outlineIcon: SVGS.QuiltOutline,
    gridIcon: SVGS.QuiltIcon,
    gridSelectedIcon: SVGS.QuiltSelectedIcon,
    color: colors.text,
  },

  [TopicType.QNA]: {
    key: 'qna',
    label: 'Q&A',
    type: TopicType.QNA,
    title: 'Q&A',
    tabTitle: 'Q&A',
    icon: SVGS.PatternIcon,
    outlineIcon: SVGS.PatternIcon,
    gridIcon: SVGS.PatternIcon,
    gridSelectedIcon: SVGS.PatternSelectedIcon,
    color: colors.text,
  },

  [TopicType.CUSTOM_PRINTS]: {
    key: 'custom_print',
    label: 'Custom Prints',
    type: TopicType.CUSTOM_PRINTS,
    title: 'Custom Print',
    tabTitle: 'Custom Prints',
    icon: SVGS.QuiltIcon,
    outlineIcon: SVGS.QuiltOutline,
    gridIcon: SVGS.QuiltIcon,
    gridSelectedIcon: SVGS.QuiltSelectedIcon,
    color: colors.text,
  },

  [TopicType.WALL_ART]: {
    key: 'wallart',
    label: 'Wall Art',
    type: TopicType.WALL_ART,
    title: 'Wall Art',
    tabTitle: 'Wall Arts',
    icon: SVGS.FilterTopicList,
    outlineIcon: SVGS.FilterTopicList,
    gridIcon: SVGS.PatternIcon,
    gridSelectedIcon: SVGS.PatternSelectedIcon,
    color: colors.text,
  },
}

export const RequestActionType = {
  ACCEPT: 1,
  REJECT: 2,
  IGNORE: 3,
} as const

export type RequestActionType = (typeof RequestActionType)[keyof typeof RequestActionType]

export const CircleType = {
  friend: {
    id: 1,
    title: 'Friends',
    // icon: Images.friendCircleIcon,
  },
  family: {
    id: 2,
    title: 'Family',
    // icon: Images.familyCircleIcon,
  },
  colleague: {
    id: 3,
    title: 'Colleagues',
    // icon: Images.colleagueCircleIcon,
  },

  internal: {
    id: 4,
    title: 'Internal',
    // icon: Images.colleagueCircleIcon,
  },
  openGroup: {
    id: 5,
    title: 'Open Group',
    // icon: Images.circles,
  },
}

export const CreateTopicTypes = [
  {
    label: 'Album',
    type: 2,
    title: 'Collection',
    icon: SVGS.FilterTopicAlbum,
    description: 'Create a gallery of Photos',
  },
  {
    label: 'Discussion',
    type: 4,
    title: 'Conversation',
    icon: SVGS.FilterTopicDiscussion,
    description: 'Create a chat thread',
  },
  // {
  //   label: 'Document',
  //   type: 5,
  //   title: 'Document',
  //   icon: SVGS.FilterTopicDocument,
  //   description: 'Create a Document of images and notes',
  // },

  {
    label: 'Q and A',
    type: 10,
    title: 'Questions & Answers',
    icon: SVGS.FilterTopicDiscussion,
    description: 'Ask your question',
  },

  {
    label: 'List',
    type: 1,
    title: 'List',
    icon: SVGS.FilterTopicList,
    description: 'Add notes and images and collect your thoughts',
  },
  // {
  //   label: 'Task List',
  //   type: 3,
  //   title: 'Task List',
  //   icon: SVGS.FilterTopicTaskList,
  //   description: 'Create a list of items you plan to do',
  // },
  {
    label: 'Pattern',
    type: 200,
    title: 'Pattern',
    icon: SVGS.FilterTopicList,
    description: 'Add a pattern',
  },
  {
    label: 'Gallery',
    type: 201,
    title: 'Gallery',
    icon: SVGS.FilterTopicList,
    description: 'Add a gallery',
  },
  {
    label: 'Quilt',
    type: 203,
    title: 'Quilt',
    icon: SVGS.FilterTopicList,
    description: 'Create a Quilt',
  },
  // {
  //   label: 'Wall Art',
  //   type: 202,
  //   title: 'Wall Art',
  //   icon: SVGS.FilterTopicList,
  //   description: 'Add a wall art',
  // },
]

export const CreatePrivacyTypes = [
  {
    label: 'Private',
    type: 3,
    icon: SVGS.FilterPrivacyPrivate,
    color: colors.blue,
    description: 'Keep this one to yourself',
  },
  // {
  //   label: 'One on One',
  //   type: 6,
  //   icon: SVGS.FilterPrivacyOneToOne,
  //   color: colors.green,
  //   description: 'Share it only with one person, forever.',
  // },
  // {
  //   label: 'Connections',
  //   type: 4,
  //   icon: SVGS.FilterPrivacyConnection,
  //   color: colors.purple,
  //   description: 'Choose a few or many of your connections',
  // },
  // {
  //   label: 'Circles',
  //   type: 5,
  //   icon: SVGS.FilterPrivacyCircle,
  //   color: colors.darkYellow,
  //   description: 'Narrow this content to a specific Circle.',
  // },
  {
    label: 'Public',
    type: 1,
    icon: SVGS.FilterPrivacyPublic,
    color: colors.darkRed,
    description: 'All Oddly users and guests.',
  },
]

export const ProfilePrivacyData = [
  {
    title: 'Private',
    subTitle: 'Keep this one to yourself.',
    id: 3,
    icon: SVGS.FilterPrivacyPrivate,
  },
  {
    title: 'Connections',
    subTitle: 'Choose a few or many of your connections',
    id: 4,
    icon: SVGS.FilterPrivacyConnection,
  },
  {
    title: 'Groups',
    subTitle: 'Narrow to a specific circle or group',
    id: 5,
    icon: SVGS.FilterPrivacyCircle,
  },
]

export const GroupOptions = [
  {
    name: 'Family',
    type: 1,
  },
  {
    name: 'Friends',
    type: 2,
  },
  {
    name: 'Colleague',
    type: 3,
  },
]

export const UserBasicInfoItems = [
  {
    key: 'topicCount',
    icon: SVGS.ProfileTopic,
    label: 'Topics Created',
  },
  {
    key: 'connCount',
    icon: SVGS.ProfileConnection,
    label: 'Connections',
  },
  {
    key: 'containerCount',
    icon: SVGS.ProfileCircle,
    label: 'Circles Shared',
  },
  {
    key: 'joinDate',
    icon: SVGS.ProfileMemberSince,
    label: 'Member Since',
  },
]

export const enum OddlyouNoteType {
  TEXT = 1,
  IMAGE = 2,
  INTERACTION = 3,
  COMBINED = 4, // IMAGE AND TEXT
  LOCATION = 5,
  MOOD = 6,
  PIN = 21,
}

export const enum NoteType {
  TEMPLATE = 2,
  MATERIAL = 3,
  PRINT = 4,
  COLOR = 5,
  ACCENT = 6,
  SCENE = 7,
  TEXT = 8,
  FRAME = 16, // Not 9
  MATTING = 10,
  BOARDER = 12,
  PATTERNFRAME = 20, // changed from 13 because accentScale is saved as
}

export const GuestTabs = ['Patterns', 'Quilts', 'Gallery']

export const Base64ForRTE = {
  bold: 'PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDkgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjEzODg5IDEwSDBWMEg0LjcyMjIyQzUuMjc4OTggMy4zMTM4MWUtMDUgNS44MjQwOSAwLjE1OTQxOCA2LjI5MzE3IDAuNDU5MzI2QzYuNzYyMjUgMC43NTkyMzMgNy4xMzU2OCAxLjE4NzEzIDcuMzY5MzcgMS42OTI0N0M3LjYwMzA1IDIuMTk3ODEgNy42ODcyMiAyLjc1OTQ4IDcuNjExOTIgMy4zMTExMkM3LjUzNjYyIDMuODYyNzYgNy4zMDUwMSA0LjM4MTMzIDYuOTQ0NDQgNC44MDU1NkM3LjQxNTQgNS4xODIyIDcuNzU4MDMgNS42OTU1NiA3LjkyNTE4IDYuMjc0OThDOC4wOTIzMiA2Ljg1NDQgOC4wNzU3NSA3LjQ3MTM4IDcuODc3NzYgOC4wNDA5OUM3LjY3OTc3IDguNjEwNjEgNy4zMTAwOCA5LjEwNDg0IDYuODE5NTkgOS40NTU2N0M2LjMyOTEgOS44MDY1IDUuNzQxOTIgOS45OTY2NyA1LjEzODg5IDEwWk0xLjY2NjY3IDguMzMzMzNINS4xMjc3OEM1LjI5MTkzIDguMzMzMzMgNS40NTQ0OCA4LjMwMSA1LjYwNjEzIDguMjM4MThDNS43NTc3OSA4LjE3NTM3IDUuODk1NTkgOC4wODMyOSA2LjAxMTY2IDcuOTY3MjJDNi4xMjc3MyA3Ljg1MTE0IDYuMjE5ODEgNy43MTMzNSA2LjI4MjYzIDcuNTYxNjlDNi4zNDU0NSA3LjQxMDAzIDYuMzc3NzggNy4yNDc0OSA2LjM3Nzc4IDcuMDgzMzNDNi4zNzc3OCA2LjkxOTE4IDYuMzQ1NDUgNi43NTY2NCA2LjI4MjYzIDYuNjA0OThDNi4yMTk4MSA2LjQ1MzMyIDYuMTI3NzMgNi4zMTU1MiA2LjAxMTY2IDYuMTk5NDVDNS44OTU1OSA2LjA4MzM4IDUuNzU3NzkgNS45OTEzIDUuNjA2MTMgNS45Mjg0OEM1LjQ1NDQ4IDUuODY1NjcgNS4yOTE5MyA1LjgzMzMzIDUuMTI3NzggNS44MzMzM0gxLjY2NjY3VjguMzMzMzNaTTEuNjY2NjcgNC4xNjY2N0g0LjcyMjIyQzQuODg2MzcgNC4xNjY2NyA1LjA0ODkyIDQuMTM0MzMgNS4yMDA1OCA0LjA3MTUyQzUuMzUyMjMgNC4wMDg3IDUuNDkwMDMgMy45MTY2MiA1LjYwNjExIDMuODAwNTVDNS43MjIxOCAzLjY4NDQ4IDUuODE0MjUgMy41NDY2OCA1Ljg3NzA3IDMuMzk1MDJDNS45Mzk4OSAzLjI0MzM2IDUuOTcyMjIgMy4wODA4MiA1Ljk3MjIyIDIuOTE2NjdDNS45NzIyMiAyLjc1MjUxIDUuOTM5ODkgMi41ODk5NyA1Ljg3NzA3IDIuNDM4MzFDNS44MTQyNSAyLjI4NjY2IDUuNzIyMTggMi4xNDg4NiA1LjYwNjExIDIuMDMyNzhDNS40OTAwMyAxLjkxNjcxIDUuMzUyMjMgMS44MjQ2NCA1LjIwMDU4IDEuNzYxODJDNS4wNDg5MiAxLjY5OSA0Ljg4NjM3IDEuNjY2NjcgNC43MjIyMiAxLjY2NjY3SDEuNjY2NjdWNC4xNjY2N1oiIGZpbGw9IiM4NjhGQUQiLz4KPC9zdmc+Cg==',
  italic:
    'PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDEuMTExMTFWMEgyLjc3Nzc4VjEuMTExMTFINS42MzMzM0wzLjIwNTU2IDguODg4ODlIMFYxMEg3LjIyMjIyVjguODg4ODlINC4zNjY2N0w2Ljc5NDQ0IDEuMTExMTFIMTBaIiBmaWxsPSIjODY4RkFEIi8+Cjwvc3ZnPgo=',
  underline:
    'PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KDTwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIFRyYW5zZm9ybWVkIGJ5OiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgLTAuNSAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KDTxnIGlkPSJTVkdSZXBvX2JnQ2FycmllciIgc3Ryb2tlLXdpZHRoPSIwIi8+Cg08ZyBpZD0iU1ZHUmVwb190cmFjZXJDYXJyaWVyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KDTxnIGlkPSJTVkdSZXBvX2ljb25DYXJyaWVyIj4gPHBhdGggZD0iTTUuNSAxNy4yNUM1LjA4NTc5IDE3LjI1IDQuNzUgMTcuNTg1OCA0Ljc1IDE4QzQuNzUgMTguNDE0MiA1LjA4NTc5IDE4Ljc1IDUuNSAxOC43NVYxNy4yNVpNMTkuNSAxOC43NUMxOS45MTQyIDE4Ljc1IDIwLjI1IDE4LjQxNDIgMjAuMjUgMThDMjAuMjUgMTcuNTg1OCAxOS45MTQyIDE3LjI1IDE5LjUgMTcuMjVWMTguNzVaTTE2LjI1IDZDMTYuMjUgNS41ODU3OSAxNS45MTQyIDUuMjUgMTUuNSA1LjI1QzE1LjA4NTggNS4yNSAxNC43NSA1LjU4NTc5IDE0Ljc1IDZIMTYuMjVaTTkuNSAxMy4xNDNIOC43NUg5LjVaTTEwLjI1IDZDMTAuMjUgNS41ODU3OSA5LjkxNDIxIDUuMjUgOS41IDUuMjVDOS4wODU3OSA1LjI1IDguNzUgNS41ODU3OSA4Ljc1IDZIMTAuMjVaTTUuNSAxOC43NUgxOS41VjE3LjI1SDUuNVYxOC43NVpNMTQuNzUgNlYxMy4xNDNIMTYuMjVWNkgxNC43NVpNMTQuNzUgMTMuMTQzQzE0Ljc1IDE0LjM4NTYgMTMuNzQyNiAxNS4zOTMgMTIuNSAxNS4zOTNWMTYuODkzQzE0LjU3MTEgMTYuODkzIDE2LjI1IDE1LjIxNDEgMTYuMjUgMTMuMTQzSDE0Ljc1Wk0xMi41IDE1LjM5M0MxMS4yNTc0IDE1LjM5MyAxMC4yNSAxNC4zODU2IDEwLjI1IDEzLjE0M0g4Ljc1QzguNzUgMTUuMjE0MSAxMC40Mjg5IDE2Ljg5MyAxMi41IDE2Ljg5M1YxNS4zOTNaTTEwLjI1IDEzLjE0M1Y2SDguNzVWMTMuMTQzSDEwLjI1WiIgZmlsbD0iIzg2OEZBRCIvPiA8L2c+Cg08L3N2Zz4=',
  strikethrough:
    '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',
  alignRight:
    'PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KDTwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIFRyYW5zZm9ybWVkIGJ5OiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHJva2U9IiM4NjhGQUQiPgoNPGcgaWQ9IlNWR1JlcG9fYmdDYXJyaWVyIiBzdHJva2Utd2lkdGg9IjAiLz4KDTxnIGlkPSJTVkdSZXBvX3RyYWNlckNhcnJpZXIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgoNPGcgaWQ9IlNWR1JlcG9faWNvbkNhcnJpZXIiPiA8cGF0aCBkPSJNOCAxMEgyMU0zIDE0SDIxTTggMThIMjFNMyA2SDIxIiBzdHJva2U9IiM4NjhGQUQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+IDwvZz4KDTwvc3ZnPg==',
  alignLeft:
    'PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KDTwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIFRyYW5zZm9ybWVkIGJ5OiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KDTxnIGlkPSJTVkdSZXBvX2JnQ2FycmllciIgc3Ryb2tlLXdpZHRoPSIwIi8+Cg08ZyBpZD0iU1ZHUmVwb190cmFjZXJDYXJyaWVyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KDTxnIGlkPSJTVkdSZXBvX2ljb25DYXJyaWVyIj4gPHBhdGggZD0iTTMgMTBIMTZNMyAxNEgyMU0zIDE4SDE2TTMgNkgyMSIgc3Ryb2tlPSIjODY4RkFEIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPiA8L2c+Cg08L3N2Zz4=',
  alignCenter:
    'PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KDTwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIFRyYW5zZm9ybWVkIGJ5OiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KDTxnIGlkPSJTVkdSZXBvX2JnQ2FycmllciIgc3Ryb2tlLXdpZHRoPSIwIi8+Cg08ZyBpZD0iU1ZHUmVwb190cmFjZXJDYXJyaWVyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KDTxnIGlkPSJTVkdSZXBvX2ljb25DYXJyaWVyIj4gPHBhdGggZD0iTTMgNkgyMU0zIDE0SDIxTTE3IDEwSDdNMTcgMThINyIgc3Ryb2tlPSIjODY4RkFEIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPiA8L2c+Cg08L3N2Zz4=',
  alignJustify:
    'PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KDTwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIFRyYW5zZm9ybWVkIGJ5OiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHJva2U9IiM4NjhGQUQiPgoNPGcgaWQ9IlNWR1JlcG9fYmdDYXJyaWVyIiBzdHJva2Utd2lkdGg9IjAiLz4KDTxnIGlkPSJTVkdSZXBvX3RyYWNlckNhcnJpZXIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgoNPGcgaWQ9IlNWR1JlcG9faWNvbkNhcnJpZXIiPiA8cGF0aCBkPSJNMyAxMEgyMU0zIDE0SDIxTTMgMThIMjFNMyA2SDIxIiBzdHJva2U9IiM4NjhGQUQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+IDwvZz4KDTwvc3ZnPg==',
  listOrdered:
    'PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMDgzMjkgOC4yNUgxMy4wODMzVjkuMjVINi4wODMyOVY4LjI1Wk02LjA4MzI5IDEuMjVIMTMuMDgzM1YyLjI1SDYuMDgzMjlWMS4yNVoiIGZpbGw9IiM4NjhGQUQiLz4KPHBhdGggZD0iTTIuMTY2NjcgMy4zMzMzM1YwSDEuMzMzMzNWMC40MTY2NjdIMC41VjEuMjVIMS4zMzMzM1YzLjMzMzMzSDAuNVY0LjE2NjY3SDNWMy4zMzMzM0gyLjE2NjY3Wk0zIDEwSDAuNVY4LjMzMzMzQzAuNSA4LjExMjMyIDAuNTg3Nzk3IDcuOTAwMzYgMC43NDQwNzggNy43NDQwOEMwLjkwMDM1OCA3LjU4NzggMS4xMTIzMiA3LjUgMS4zMzMzMyA3LjVIMi4xNjY2N1Y2LjY2NjY3SDAuNVY1LjgzMzMzSDIuMTY2NjdDMi4zODc2OCA1LjgzMzMzIDIuNTk5NjQgNS45MjExMyAyLjc1NTkyIDYuMDc3NDFDMi45MTIyIDYuMjMzNjkgMyA2LjQ0NTY1IDMgNi42NjY2N1Y3LjVDMyA3LjcyMTAxIDIuOTEyMiA3LjkzMjk3IDIuNzU1OTIgOC4wODkyNkMyLjU5OTY0IDguMjQ1NTQgMi4zODc2OCA4LjMzMzMzIDIuMTY2NjcgOC4zMzMzM0gxLjMzMzMzVjkuMTY2NjdIM1YxMFoiIGZpbGw9IiM4NjhGQUQiLz4KPC9zdmc+Cg==',
  listUnordered:
    'PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMyAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNSAzQzIuMzI4NDMgMyAzIDIuMzI4NDMgMyAxLjVDMyAwLjY3MTU3MyAyLjMyODQzIDAgMS41IDBDMC42NzE1NzMgMCAwIDAuNjcxNTczIDAgMS41QzAgMi4zMjg0MyAwLjY3MTU3MyAzIDEuNSAzWiIgZmlsbD0iIzg2OEZBRCIvPgo8cGF0aCBkPSJNMS41IDEwQzIuMzI4NDMgMTAgMyA5LjMyODQzIDMgOC41QzMgNy42NzE1NyAyLjMyODQzIDcgMS41IDdDMC42NzE1NzMgNyAwIDcuNjcxNTcgMCA4LjVDMCA5LjMyODQzIDAuNjcxNTczIDEwIDEuNSAxMFoiIGZpbGw9IiM4NjhGQUQiLz4KPHBhdGggZD0iTTYgOEgxM1Y5SDZWOFpNNiAxSDkuNUgxM1YySDZWMVoiIGZpbGw9IiM4NjhGQUQiLz4KPC9zdmc+Cg==',
  link: 'PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KDTwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIFRyYW5zZm9ybWVkIGJ5OiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KDTxnIGlkPSJTVkdSZXBvX2JnQ2FycmllciIgc3Ryb2tlLXdpZHRoPSIwIi8+Cg08ZyBpZD0iU1ZHUmVwb190cmFjZXJDYXJyaWVyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KDTxnIGlkPSJTVkdSZXBvX2ljb25DYXJyaWVyIj4gPHBhdGggZD0iTTEyLjc5MTcgMTUuNzk5MUwxNC4yMjIzIDE0LjM2NzZDMTYuNTkyNiAxMS45OTU5IDE2LjU5MjYgOC4xNTA1NCAxNC4yMjIzIDUuNzc4OEMxMS44NTIxIDMuNDA3MDcgOC4wMDkxIDMuNDA3MDcgNS42Mzg4NSA1Ljc3ODhMMi43Nzc2OSA4LjY0MTc0QzAuNDA3NDM2IDExLjAxMzUgMC40MDc0MzYgMTQuODU4OCAyLjc3NzY5IDE3LjIzMDZDMy44NzY4OCAxOC4zMzA0IDUuMjkyNzkgMTguOTIwMiA2LjczMTY1IDE5IiBzdHJva2U9IiM4NjhGQUQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4gPHBhdGggZD0iTTExLjIwODMgOC4yMDA5Mkw5Ljc3NzY5IDkuNjMyMzlDNy40MDc0NCAxMi4wMDQxIDcuNDA3NDQgMTUuODQ5NSA5Ljc3NzY5IDE4LjIyMTJDMTIuMTQ3OSAyMC41OTI5IDE1Ljk5MDkgMjAuNTkyOSAxOC4zNjEyIDE4LjIyMTJMMjEuMjIyMyAxNS4zNTgzQzIzLjU5MjYgMTIuOTg2NSAyMy41OTI2IDkuMTQxMTggMjEuMjIyMyA2Ljc2OTQ1QzIwLjEyMzEgNS42Njk1NyAxOC43MDcyIDUuMDc5NzYgMTcuMjY4MyA1IiBzdHJva2U9IiM4NjhGQUQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4gPC9nPgoNPC9zdmc+',
  unlink:
    'PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KDTwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIFRyYW5zZm9ybWVkIGJ5OiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KDTxnIGlkPSJTVkdSZXBvX2JnQ2FycmllciIgc3Ryb2tlLXdpZHRoPSIwIi8+Cg08ZyBpZD0iU1ZHUmVwb190cmFjZXJDYXJyaWVyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KDTxnIGlkPSJTVkdSZXBvX2ljb25DYXJyaWVyIj4gPHBhdGggZD0iTTEwIDUuMDQ4NzdMMTAuMzY3IDQuNzA1NjNDMTIuNzk5NSAyLjQzMTQ2IDE2Ljc0MzIgMi40MzE0NiAxOS4xNzU3IDQuNzA1NjNDMjEuNjA4MSA2Ljk3OTggMjEuNjA4MSAxMC42NjcgMTkuMTc1NyAxMi45NDExTDE2Ljk3MzUgMTUiIHN0cm9rZT0iIzg2OEZBRCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPiA8cGF0aCBkPSJNMTQgMTguOTI3OEwxMy42MzQ1IDE5LjI3NzNDMTEuMjEyMyAyMS41OTM3IDcuMjU0MzQgMjEuNTY0NCA0LjgzMjA5IDE5LjI0OEMyLjQzMzc2IDE2Ljk1NDYgMi4zNzYzOSAxMy4yMTUzIDQuNzQwOTUgMTAuODlMNS42NDU5NCAxMCIgc3Ryb2tlPSIjODY4RkFEIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+IDxwYXRoIGQ9Ik02LjU4NzM5IDNMNy41IDUuMjA1MjEiIHN0cm9rZT0iIzg2OEZBRCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPiA8cGF0aCBkPSJNMy41MDIzOCA2LjA4NjU4TDkuMDUwMjEgOC43OTQ1MyIgc3Ryb2tlPSIjODY4RkFEIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+IDwvZz4KDTwvc3ZnPg==',
  emoji:
    'PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNiIgY3k9IjYiIHI9IjUuNSIgc3Ryb2tlPSIjODY4RkFEIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTMuNzQ4MjMgOC4wNDQ2M0M0LjAxNDA2IDguMjc0ODUgNC4zNjY3MSA4LjQ0MzAyIDQuNzUwMjcgOC41NTM3NUM1LjEzNzc5IDguNjY1NjEgNS41NjgxMiA4LjcyMjIyIDYuMDAwMDUgOC43MjIyMkM2LjQzMTk4IDguNzIyMjIgNi44NjIzMiA4LjY2NTYxIDcuMjQ5ODQgOC41NTM3NUM3LjYzMzQgOC40NDMwMiA3Ljk4NjA1IDguMjc0ODUgOC4yNTE4OCA4LjA0NDYzIiBzdHJva2U9IiM4NjhGQUQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSI0LjMzMzM5IiBjeT0iNC44ODg1NiIgcj0iMC41NTU1NTYiIGZpbGw9IiM4NjhGQUQiIHN0cm9rZT0iIzg2OEZBRCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxjaXJjbGUgY3g9IjcuNjY2NjQiIGN5PSI0Ljg4ODU2IiByPSIwLjU1NTU1NiIgZmlsbD0iIzg2OEZBRCIgc3Ryb2tlPSIjODY4RkFEIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==',
}

export const DEFAULT_FIRST_NOTE = `<p>It's just the beginning</p>`
export const AVATAR_FILE_EXTENSIONS = ['jpg', 'png', 'jpeg']

export const AVATAR_BG_COLORS = [
  '#FFC979',
  '#FF7991',
  '#68EFAE',
  '#7996FF',
  '#C479FF',
  '#79D7FF',
  '#FF79D9',
  '#A8EA66',
  '#6F38C5',
  '#E38B29',
  '#107FA3',
  '#547087',
  '#5E9980',
  '#443C68',
  '#A75D5D',
  '#6D66E4',
  '#10A19D',
  '#65647C',
]

export const MandatoryNoteTypes = [NoteType.ACCENT, NoteType.COLOR]

interface PatternAssetInfo {
  categoryName: string
  icon: string
}

export const TemplateCategories: string[] = ['Template Cat 1', 'Template Cat 2', 'Template Cat 3']

export const PatternAssetTypesData: Record<NoteType, PatternAssetInfo> = {
  [NoteType.TEMPLATE]: {
    categoryName: 'template',
    icon: SVGS.PatternMeshIcon,
  },

  [NoteType.MATERIAL]: {
    categoryName: 'material',
    icon: SVGS.MaterialIcon,
  },

  [NoteType.PRINT]: {
    categoryName: 'print',
    icon: SVGS.PrintIcon,
  },
  [NoteType.COLOR]: {
    categoryName: 'color',
    icon: SVGS.ColorsIcon,
  },
  [NoteType.ACCENT]: {
    categoryName: 'accent',
    icon: SVGS.AccentIcon,
  },
  [NoteType.SCENE]: {
    categoryName: 'scene',
    icon: SVGS.SceneIcon,
  },
  [NoteType.TEXT]: {
    categoryName: 'text',
    icon: SVGS.PatternMeshIcon,
  },
  [NoteType.FRAME]: {
    categoryName: 'frame',
    icon: SVGS.FrameSquareIcon,
  },
  [NoteType.MATTING]: {
    categoryName: 'matting',
    icon: SVGS.PatternMeshIcon,
  },
  [NoteType.BOARDER]: {
    categoryName: 'boarder',
    icon: SVGS.PatternMeshIcon,
  },
  [NoteType.PATTERNFRAME]: {
    categoryName: 'patternFrame',
    icon: SVGS.DesignMultiple,
  },
}

export const PatternAssetsMap: Record<string, PatternAssetInfo[]> = {
  '200': [
    // PatternAssetTypesData[NoteType.TEMPLATE],
    PatternAssetTypesData[NoteType.ACCENT], // Moved to top and renamed to 'Template' in UI
    PatternAssetTypesData[NoteType.MATERIAL],
    PatternAssetTypesData[NoteType.PRINT],
    PatternAssetTypesData[NoteType.COLOR],
    PatternAssetTypesData[NoteType.SCENE],
    // PatternAssetTypesData[NoteType.PATTERNFRAME],
    // PatternAssetTypesData[NoteType.FRAME],
    // PatternAssetTypesData[NoteType.MATTING],
  ], // pattern
  '201': [
    PatternAssetTypesData[NoteType.TEMPLATE],
    PatternAssetTypesData[NoteType.MATERIAL],
    PatternAssetTypesData[NoteType.PRINT],
    PatternAssetTypesData[NoteType.COLOR],
    // PatternAssetTypesData[NoteType.ACCENT],
    PatternAssetTypesData[NoteType.FRAME],
    PatternAssetTypesData[NoteType.MATTING],
    // PatternAssetTypesData[NoteType.BOARDER],
    // PatternAssetTypesData[NoteType.SCENE],
  ], // gallery
  '202': [
    PatternAssetTypesData[NoteType.TEMPLATE],
    PatternAssetTypesData[NoteType.MATERIAL],
    PatternAssetTypesData[NoteType.PRINT],
    PatternAssetTypesData[NoteType.COLOR],
    PatternAssetTypesData[NoteType.SCENE],
    PatternAssetTypesData[NoteType.BOARDER],
  ], // wall art
  '203': [
    PatternAssetTypesData[NoteType.TEMPLATE],
    PatternAssetTypesData[NoteType.MATERIAL],
    PatternAssetTypesData[NoteType.PRINT],
    PatternAssetTypesData[NoteType.COLOR],
    PatternAssetTypesData[NoteType.SCENE],
    PatternAssetTypesData[NoteType.ACCENT],
    PatternAssetTypesData[NoteType.BOARDER],
  ], // QUILT
  '205': [
    PatternAssetTypesData[NoteType.PRINT],
    PatternAssetTypesData[NoteType.COLOR],
    PatternAssetTypesData[NoteType.ACCENT],
  ], // CUSTOM PRINTS
}

export const TopicApplication = {
  DirectMessage: 1,
  Oddlyou: 2,
  NewsFeed: 3,
  Meshdom: 20,
  default: 20,
}

export const DEFAULT_TOPIC_APPLICATION = TopicApplication.default

export const TopicTypeAndApplicationDic: Record<string, number> = {
  '0': TopicApplication.Meshdom,
  '7': TopicApplication.DirectMessage,
  '4': TopicApplication.Oddlyou,
  '2': TopicApplication.Oddlyou,
  '110': TopicApplication.Oddlyou,
  '10': TopicApplication.Oddlyou,
  '200': TopicApplication.Meshdom,
  '201': TopicApplication.Meshdom,
  '203': TopicApplication.Meshdom,
  '205': TopicApplication.Meshdom,
}

export const PatternNoteTypes: Record<string, string> = {
  templateID: '2',
  materialID: '3',
  print: '4',
  color: '5',
  accentID: '6',
  sceneID: '7',
  text: '8',
  preview: '9',
  merge: '10',
  position: '11',
  boarder: '12',
  accentScale: '13',
  accentNumber: '14',
  accentRotation: '15',
  frameID: '16',
  matting: '17',
  hidden: '18',
  printTiling: '19',
  patternFrameID: '20',
}

export const PatternNoteTypeLabels: Record<keyof typeof PatternNoteTypes, string> = {
  templateID: 'Template',
  materialID: 'Material',
  print: 'Print',
  color: 'Color',
  accentID: 'Template',
  sceneID: 'Scene',
  text: 'Text',
  preview: 'Preview',
  merge: 'Merge',
  position: 'Position',
  boarder: 'Border',
  accentScale: 'Accent Scale',
  accentNumber: 'Accent Number',
  accentRotation: 'Accent Rotation',
  frameID: 'Frame',
  matting: 'Matting',
  hidden: 'Hidden',
  printTiling: 'Print Tiling',
  patternFrameID: 'Pattern Frame',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PatternAssetTabs: Record<string, any[]> = {
  '200': [
    // {
    //   title: 'Settings',
    //   key: 'settings',
    //   icon: SVGS.SettingsIcon,
    // },
    {
      key: 'album',
      icon: SVGS.AlbumOutlineIcon,
    },
    {
      key: 'upload',
      icon: SVGS.UploadIcon,
    },
  ],
  '201': [
    {
      title: 'Settings',
      key: 'settings',
      icon: SVGS.SettingsIcon,
    },
    {
      key: 'album',
      icon: SVGS.AlbumOutlineIcon,
    },
    {
      key: 'upload',
      icon: SVGS.UploadIcon,
    },
  ],
  '202': [
    {
      key: 'album',
      icon: SVGS.AlbumOutlineIcon,
    },
    {
      key: 'upload',
      icon: SVGS.UploadIcon,
    },
  ],
  '203': [
    {
      key: 'album',
      icon: SVGS.AlbumOutlineIcon,
    },
    {
      key: 'upload',
      icon: SVGS.UploadIcon,
    },
  ],
  '205': [
    {
      title: 'Settings',
      key: 'settings',
      icon: SVGS.SettingsIcon,
    },
  ],
}

export const TopicTypeOptionsForCreate: TopicType[] = [
  TopicType.PATTERN,
  // TopicType.CUSTOM_PRINTS,
  TopicType.ALBUM,
  //TopicType.GALLERY,
]

export const BoarderWidthRange = [0, 5, 10, 20, 25]
export const MattingWidthRange = [0, 5, 10, 20] //, 25]
export const BoarderTypes = ['square', 'triangle', 'triangle 2']
export const SIDE_PANEL_WIDTH = '450px'
export const SOCKET_PING_INTERVAL = 30 * 1000
export const SHOW_WHITE_LIST_ONLY = true
export const WHITE_LISTED_TOPIC_TYPES: TopicType[] = [
  TopicType.ALBUM,
  TopicType.PATTERN,
  TopicType.PIN_COLLECTION,
  // TopicType.QUILT,
  // TopicType.GALLERY,
  // TopicType.CUSTOM_PRINTS,
]
export const DEFAULT_ACCENT_SLIDER_DATA: AccentSlidersData = {
  scale: 0,
  tiling: 1,
  rotation: 0.001,
}

export const defaultPatternDraft = { templateID: 2 }
export const defaultGalleryDraft = { templateID: 400 }

export const getDefaultDraft = (topicType: TopicType) => {
  switch (topicType) {
    case TopicType.GALLERY:
      return defaultGalleryDraft
    case TopicType.PATTERN:
    default:
      return defaultPatternDraft
  }
}

export const whiteListFilterFn = (item: Topic): boolean =>
  WHITE_LISTED_TOPIC_TYPES.includes(Number(item.topicType))

export const ANONYMOUS_PATTERN_DEFAULT_NAME = 'Untitled Pattern'

const DEFAULT_VALUES_BASE = {
  templateID: 2,
  accentID: null,
  frameID: null,
  sceneID: null,
  matting: { width: 0 },
  accentScale: null,
  accentNumber: null,
  accentRotation: null,
  printTiling: 1,
  materialID: {},
  shaderID: {},
  color: {},
  print: {},
  hidden: {},
  position: {
    template_Shape_01: { x: 0, z: 0 },
  },
  merge: [],
}

const DEFAULT_VALUES = {
  ...DEFAULT_VALUES_BASE,
}

const DEFAULT_VALUES_WITH_ACCENT = {
  ...DEFAULT_VALUES_BASE,
  accentScale: 1,
  accentNumber: 1,
  accentRotation: 0.001,
}

function deepEqual(a: unknown, b: unknown): boolean {
  if (a === b) return true
  if (typeof a !== typeof b) return false
  if (a === null || b === null) return a === b

  if (Array.isArray(a) || Array.isArray(b)) {
    if (!Array.isArray(a) || !Array.isArray(b)) return false
    if (a.length !== b.length) return false
    return a.every((v, i) => deepEqual(v, b[i]))
  }

  if (typeof a === 'object' && typeof b === 'object') {
    const aObj = a as Record<string, unknown>
    const bObj = b as Record<string, unknown>
    const aKeys = Object.keys(aObj)
    const bKeys = Object.keys(bObj)
    if (aKeys.length !== bKeys.length) return false
    return aKeys.every((k) => deepEqual(aObj[k], bObj[k]))
  }

  return false
}

export const isDefaultValue = (draftValue: any, draftKey: string, hasAccent: boolean): boolean => {
  const defaultSource = hasAccent ? DEFAULT_VALUES_WITH_ACCENT : DEFAULT_VALUES

  if (!(draftKey in defaultSource)) return false
  const defaultValue = defaultSource[draftKey as keyof typeof defaultSource]

  return deepEqual(draftValue, defaultValue)
}
